module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "paymentScreen"
    }
  }, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Number of Sections")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v(_vm._s(_vm.fileSearchCharge.sectionCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Charge per section")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v("$" + _vm._s(_vm.fileSearchCharge.sectionCharge.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v("$" + _vm._s(_vm.subtotalCharge.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("\r\n                    Processing Fee (" + _vm._s((_vm.paymentConfig.transactionFeeRate * 100.00).toFixed(2)) + "% + $" + _vm._s((_vm.paymentConfig.transactionFeeFlat || 0).toFixed(2)) + ")\r\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_vm._v("$" + _vm._s(_vm.processingFee.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('')
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Total charge")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticClass: "textValue"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.totalCharge.toFixed(2)))])])])]), _vm._v(" "), (!_vm.validationResult.isValid) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.validationResult,
      "header": ''
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "value": "Cancel"
    },
    on: {
      "click": _vm.cancel
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.canSubmit) ? _c('div', [(_vm.fileSearchCharge.sectionCharge === 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "value": "Continue"
    },
    on: {
      "click": _vm.noCharge
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.fileSearchCharge.sectionCharge != 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "value": "Pay"
    },
    on: {
      "click": _vm.getSquareCheckout
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.fileSearchCharge.sectionCharge != 0 && _vm.paymentConfig.enableMockSquareFlow) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    staticClass: "btn btn-default btn-block",
    attrs: {
      "value": "Mock Pay"
    },
    on: {
      "click": _vm.getMockSquareCheckout
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "value": "Cancel"
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), (_vm.fileSearchCharge.sectionCharge != 0) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("\r\n                    *You will be re-directed to Square payment page once you clicked \"Pay\"\r\n                ")]) : _vm._e()]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "paymentAlert",
      "role": "warning"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("Wyoming State Historic Preservation Office")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "30px",
      "text-align": "center"
    }
  }, [_c('b', [_vm._v("WyoTrack File Search Refund Policy")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("All file search purchases ordered and paid for in the WyoTrack system are final. There will be no refunds issued for file searches purchased in WyoTrack.")]), _vm._v(" "), _c('strong', [_vm._v("Please Note:")]), _vm._v(" Once a file search has been submitted, payment is automatically created. "), _c('strong', [_vm._v("The payment cannot be refunded.")]), _vm._v(" Please ensure you have the correct information before submitting.\r\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be0c34f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FileSearchPayment.vue
// module id = 957
// module chunks = 1